import { render, staticRenderFns } from "./ElderResidentsBySubsidiesType.vue?vue&type=template&id=66aae862&scoped=true&"
import script from "./ElderResidentsBySubsidiesType.vue?vue&type=script&lang=js&"
export * from "./ElderResidentsBySubsidiesType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66aae862",
  null
  
)

export default component.exports